import {
  GET_DELIVERY_SLOTS,
  GET_DELIVERY_SLOTS_SUCCESS,
  GET_DELIVERY_SLOTS_FAILURE,
  GET_ADDRESS_BY_POSTALCODE,
  GET_ADDRESS_BY_POSTALCODE_SUCCESS,
  GET_ADDRESS_BY_POSTALCODE_FAILURE,
  GET_DELIVERY_ADDRESS_LIST,
  GET_DELIVERY_ADDRESS_LIST_SUCCESS,
  GET_DELIVERY_ADDRESS_LIST_FAILURE,
  UPDATE_DELIVERY_ADDRESS,
  UPDATE_DELIVERY_ADDRESS_SUCCESS,
  UPDATE_DELIVERY_ADDRESS_FAILURE,
  DELETE_DELIVERY_ADDRESS,
  DELETE_DELIVERY_ADDRESS_SUCCESS,
  DELETE_DELIVERY_ADDRESS_FAILURE,
  GET_PAYMENT_TYPES_SUCCESS,
  GET_CUSTOMER_IDS_SUCCESS,
  GET_BILLING_ADDRESS_LIST,
  GET_BILLING_ADDRESS_LIST_SUCCESS,
  GET_BILLING_ADDRESS_LIST_FAILURE,
  GET_BILLING_ADDRESS_LIST_SERVICE_NO,
  GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS,
  GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE,
  GET_POPSTATION_LIST,
  GET_POPSTATION_LIST_SUCCESS,
  GET_POPSTATION_LIST_FAILURE,
  GET_POPSTATION_ADDRESS_BY_POSTALCODE,
  GET_POPSTATION_ADDRESS_BY_POSTALCODE_SUCCESS,
  GET_POPSTATION_ADDRESS_BY_POSTALCODE_FAILURE,
  GET_ALL_DELIVERY_CHARGES_REQUEST,
  GET_ALL_DELIVERY_CHARGES_SUCCESS,
  GET_ALL_DELIVERY_CHARGES_FAILURE,
  GET_SPLIT_PAYMENT_TYPE_FAILURE,
  GET_SPLIT_PAYMENT_TYPE_REQUEST,
  GET_SPLIT_PAYMENT_TYPE_SUCCESS,
  CHECK_CUSTOMER_CODE_ELIGIBILITY_SUCCESS,
  CHECK_CUSTOMER_CODE_ELIGIBILITY_FAILURE,
  CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST,
  GET_PORT_IN_DATE_LIST,
  GET_PORT_IN_DATE_LIST_SUCCESS,
  GET_PORT_IN_DATE_LIST_FAILURE
} from '@/actions/checkout';
import {
  PDPA_DELETE_EXIST_RESADDR_FAILURE,
  PDPA_DELETE_EXIST_RESADDR_REQUEST,
  PDPA_DELETE_EXIST_RESADDR_SUCCESS,
  PDPA_RETREIVE_RESADDRESS_FAILURE,
  PDPA_RETREIVE_RESADDRESS_REQUEST,
  PDPA_RETREIVE_RESADDRESS_SUCCESS,
  PDPA_SAVE_NEW_RESADDR_FAILURE,
  PDPA_SAVE_NEW_RESADDR_SUCCESS,
  PDPA_SAVE_NEW_RESADDR_REQUEST,
  PDPA_UPDATE_EXIST_RESADDR_FAILURE,
  PDPA_UPDATE_EXIST_RESADDR_REQUEST,
  PDPA_UPDATE_EXIST_RESADDR_SUCCESS,
  GET_ESIM_CARD_PROFILE_TYPE,
  GET_ESIM_CARD_PROFILE_TYPE_FAILURE,
  GET_ESIM_CARD_PROFILE_TYPE_SUCCESS,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE,
  UPLOAD_MULTILINE_RETRIGGER_ESIM_FAILURE,
  UPLOAD_MULTILINE_RETRIGGER_ESIM_REQUEST,
  UPLOAD_MULTILINE_RETRIGGER_ESIM_SUCCESS,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET
} from '@/actions/checkout/actionTypes';

export const initialState = {
  customerIds: [],
  paymentTypes: {
    paymentMethodsForToday: [],
    paymentMethodsForMonthly: [],
    subsidyAmount: ''
  },
  deliveryAddressLoading: false,
  billingAddressLoading: false,
  billingAddressServiceNoLoading: false,
  deliveryAddressList: [],
  billingAddressList: [],
  billingAddressServiceNoList: [],
  listOfPaymentAddress: [],
  deliverySlots: [],
  popStationLoading: false,
  popStationList: [],
  requesterInfo: {
    name: '',
    mobile: '',
    email: ''
  },
  deliveryOption: '',
  deliveryAddress: {
    name: ''
  },
  paymentOption: '',
  paymentAddress: {
    name: ''
  },
  termsAgreed: false,
  allDeliveryCharges: {},
  isLoading: false,
  splitPaymentType: {},
  pdpaResAddressLoading: false,
  pdpaResAddressList: [],
  newResAddress: {},
  pdpaResAddrError: '',
  custCodeEligibility: {},
  totalRecords: 0,
  portInDateList: [],
  eSIMdata: [],
  fileData: {},
  fileDataRetrigger: {},
  error: '',
  isDownloading: false,
  esimDownloadTplSuccess: false,
  esimMultiRecpCheckoutError: '',
  esimMultiRecpCheckoutSuccess: '',
  esimMultiRecpCheckoutLoading: false
};

const getUpdateDeliveryList = (action, state) => {
  switch (action.type) {
    case GET_DELIVERY_ADDRESS_LIST:
      return {
        ...state,
        deliveryAddressLoading: true
      };
    case GET_DELIVERY_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        deliveryAddressLoading: false,
        deliveryAddressList: action.data
      };

    case GET_DELIVERY_ADDRESS_LIST_FAILURE:
      return {
        ...state,
        deliveryAddressLoading: false
      };
  }
}

const getBillingAddressDetail = (action, state) => {
  switch (action.type) {
    case GET_BILLING_ADDRESS_LIST:
      return {
        ...state,
        billingAddressLoading: true
      };
    case GET_BILLING_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        billingAddressLoading: false,
        billingAddressList: action.data.t1,
        totalRecords: action.data.t2
      };
    case GET_BILLING_ADDRESS_LIST_FAILURE:
      return {
        ...state,
        billingAddressLoading: false
      };

    case GET_BILLING_ADDRESS_LIST_SERVICE_NO:
      return {
        ...state,
        billingAddressServiceNoLoading: true
      };
    case GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS:
      return {
        ...state,
        billingAddressServiceNoLoading: false,
        billingAddressServiceNoList: action.data
      };
    case GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE:
      return {
        ...state,
        billingAddressServiceNoLoading: false
      };
  }
}

const getEsimDetails = (action, state) => {
  switch (action.type) {
    case GET_ESIM_CARD_PROFILE_TYPE:
    case UPLOAD_MULTILINE_RETRIGGER_ESIM_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case GET_ESIM_CARD_PROFILE_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eSIMdata: action.data
      };
    case GET_ESIM_CARD_PROFILE_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false,
        eSIMdata: []
      };

    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST:
      return {
        ...state,
        esimMultiRecpCheckoutLoading: true,
        esimMultiRecpCheckoutError: '',
        esimMultiRecpCheckoutSuccess: ''
      }
    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS:
      return {
        ...state,
        esimMultiRecpCheckoutLoading: false,
        esimMultiRecpCheckoutSuccess: 'CHECKOUT_UPLOAD_FILE_SUCCESS',
        esimMultiRecpCheckoutError: '',
      }
    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE:
      return {
        ...state,
        esimMultiRecpCheckoutLoading: false,
        esimMultiRecpCheckoutError: action.error.response?.data?.message,
        esimMultiRecpCheckoutSuccess: ''
      };

    case UPLOAD_MULTILINE_RETRIGGER_ESIM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        fileDataRetrigger: action.data,
        error: ''
      }
    case UPLOAD_MULTILINE_RETRIGGER_ESIM_FAILURE:
      return {
        ...state,
        isLoading: false,
        fileDataRetrigger: {},
        error: action.error.response?.data?.message
      };

    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST:
      return {
        ...state,
        isDownloading: true,
        esimDownloadTplSuccess: false
      }
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS:
      return {
        ...state,
        isDownloading: false,
        esimDownloadTplSuccess: true,
        error: ''
      }
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE:
      return {
        ...state,
        isDownloading: false,
        esimDownloadTplSuccess: false,
        error: action.error.response?.data?.message
      };
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET:
      return {
        ...state,
        isDownloading: false,
        esimDownloadTplSuccess: false,
        error: ''
      }
  }
}

const checkoutReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDRESS_BY_POSTALCODE:
    case GET_ADDRESS_BY_POSTALCODE_SUCCESS:
    case GET_ADDRESS_BY_POSTALCODE_FAILURE:
    case UPDATE_DELIVERY_ADDRESS:
    case UPDATE_DELIVERY_ADDRESS_SUCCESS:
    case UPDATE_DELIVERY_ADDRESS_FAILURE:
    case DELETE_DELIVERY_ADDRESS:
    case DELETE_DELIVERY_ADDRESS_SUCCESS:
    case DELETE_DELIVERY_ADDRESS_FAILURE:
    case GET_POPSTATION_ADDRESS_BY_POSTALCODE:
    case GET_POPSTATION_ADDRESS_BY_POSTALCODE_SUCCESS:
    case GET_POPSTATION_ADDRESS_BY_POSTALCODE_FAILURE:
    case GET_ALL_DELIVERY_CHARGES_REQUEST:
      return state;

    case GET_DELIVERY_SLOTS:
    case GET_DELIVERY_SLOTS_FAILURE:
      return {
        ...state,
        deliverySlots: []
      };
    case GET_DELIVERY_SLOTS_SUCCESS:
      return {
        ...state,
        deliverySlots: action.data
      };

    case GET_DELIVERY_ADDRESS_LIST:
    case GET_DELIVERY_ADDRESS_LIST_SUCCESS:
    case GET_DELIVERY_ADDRESS_LIST_FAILURE:
      return getUpdateDeliveryList(action, state)


    case PDPA_UPDATE_EXIST_RESADDR_REQUEST:
    case PDPA_UPDATE_EXIST_RESADDR_SUCCESS:
    case PDPA_DELETE_EXIST_RESADDR_REQUEST:
    case PDPA_DELETE_EXIST_RESADDR_SUCCESS:
    case PDPA_SAVE_NEW_RESADDR_REQUEST:
      return {
        ...state,
        pdpaResAddrError: ''
      };

    case PDPA_UPDATE_EXIST_RESADDR_FAILURE:
    case PDPA_DELETE_EXIST_RESADDR_FAILURE:
    case PDPA_SAVE_NEW_RESADDR_FAILURE:
      return {
        ...state,
        pdpaResAddrError: action.error.response?.data?.message
      };

    case PDPA_SAVE_NEW_RESADDR_SUCCESS:
      return {
        ...state,
        newResAddress: action.data
      };
    case GET_CUSTOMER_IDS_SUCCESS:
      return {
        ...state,
        customerIds: action.data?.customerIds
      };

    case GET_PAYMENT_TYPES_SUCCESS:
      return {
        ...state,
        paymentTypes: {
          paymentMethodsForToday: action.data?.paymentMethodsForToday,
          paymentMethodsForMonthly: action.data?.paymentMethodsForMonthly,
          subsidyAmount: action.data?.subsidyAmount
        }
      };
    case GET_BILLING_ADDRESS_LIST:
    case GET_BILLING_ADDRESS_LIST_SUCCESS:
    case GET_BILLING_ADDRESS_LIST_FAILURE:
    case GET_BILLING_ADDRESS_LIST_SERVICE_NO:
    case GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS:
    case GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE:
      return getBillingAddressDetail(action, state)

    case GET_POPSTATION_LIST:
      return {
        ...state,
        popStationLoading: true
      };
    case GET_POPSTATION_LIST_SUCCESS:
      return {
        ...state,
        popStationLoading: false,
        popStationList: action.data
      };
    case GET_POPSTATION_LIST_FAILURE:
      return {
        ...state,
        popStationLoading: false
      };

    case GET_ALL_DELIVERY_CHARGES_SUCCESS:
      return {
        ...state,
        allDeliveryCharges: action.data
      };
    case GET_ALL_DELIVERY_CHARGES_FAILURE:
      return {
        ...state,
        allDeliveryCharges: {}
      };

    case CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST:
    case GET_SPLIT_PAYMENT_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_SPLIT_PAYMENT_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        splitPaymentType: action.data.splitpayment
      };
    case GET_SPLIT_PAYMENT_TYPE_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case PDPA_RETREIVE_RESADDRESS_REQUEST:
      return {
        ...state,
        pdpaResAddressLoading: true
      };
    case PDPA_RETREIVE_RESADDRESS_SUCCESS:
      return {
        ...state,
        pdpaResAddressLoading: false,
        pdpaResAddressList: action.data
      };
    case PDPA_RETREIVE_RESADDRESS_FAILURE:
      return {
        ...state,
        pdpaResAddressLoading: false
      };

    case CHECK_CUSTOMER_CODE_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        custCodeEligibility: action.data
      };
    case CHECK_CUSTOMER_CODE_ELIGIBILITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        custCodeEligibility: action.error.response?.data?.message
      };
    case GET_PORT_IN_DATE_LIST:
      return {
        ...state,
        portInDateListLoading: true
      };
    case GET_PORT_IN_DATE_LIST_SUCCESS:
      return {
        ...state,
        portInDateListLoading: false,
        portInDateList: action.data || []
      };

    case GET_PORT_IN_DATE_LIST_FAILURE:
      return {
        ...state,
        portInDateListLoading: false,
        portInDateList: []
      };

    case GET_ESIM_CARD_PROFILE_TYPE:
    case GET_ESIM_CARD_PROFILE_TYPE_SUCCESS:
    case GET_ESIM_CARD_PROFILE_TYPE_FAILURE:
    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST:
    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS:
    case UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE:
    case UPLOAD_MULTILINE_RETRIGGER_ESIM_REQUEST:
    case UPLOAD_MULTILINE_RETRIGGER_ESIM_SUCCESS:
    case UPLOAD_MULTILINE_RETRIGGER_ESIM_FAILURE:
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST:
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS:
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE:
    case DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET:
      return getEsimDetails(action, state);

    default:
      return state;
  }
};
export default checkoutReducers;
